import HomeTemplate from '../templates/HomeTemplate.jsx'
import { SITE_NAME, SITE_URL } from '../utils/seo.js'

const title = `Convert Video to MP3 Online – ${SITE_NAME}`
const description = 'Convert video to MP3 online for free. Paste any YouTube, TikTok, Instagram or Facebook URL and get a high-quality MP3 download in seconds — up to 320 kbps, no software required.'
const canonical = `${SITE_URL}/convert-video-to-mp3`

export default function ConvertVideoToMp3() {
  return (
    <HomeTemplate
      provider="generic"
      title={title}
      description={description}
      canonical={canonical}
      badge="Video to MP3 Converter"
      heading={
        <>
          Convert Video to{' '}
          <span className="text-gradient">MP3 Online</span>
        </>
      }
      subheading="The easiest way to convert video to MP3. Supports YouTube, TikTok, Instagram, and Facebook. Choose 128, 192, or 320 kbps — completely free."
    />
  )
}
